module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/paper_tablet-d8a794e82d3eab3760dfd03aa74f7a79.png";